import { SpriteSvgType } from '../components/sprite-svg';
import getFormatMessage from '../locales/get-format-message';
import {
  ISystemMenuItem,
  SystemMenuId,
  SystemMenuType,
} from '../model/system/menu';

export const getAdminMenus = (showDevMenu: boolean): ISystemMenuItem[] => {
  return [
    {
      type: SystemMenuType.Group,
      id: SystemMenuId.SupportAccess,
      name: getFormatMessage('support_access'),
      hidden: false,
      fixed: false,
      url: '/admin/organization-manage',
    },
    {
      type: SystemMenuType.Group,
      id: SystemMenuId.UserManage,
      name: getFormatMessage('user_manage'),
      fixed: true,
      subMenus: [
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.UserListManage,
          icon: SpriteSvgType.AccountCenter,
          name: getFormatMessage('user_list'),
          hidden: false,
          fixed: false,
          url: '/admin/user',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.AdminAccountManage,
          icon: SpriteSvgType.AccountApprove,
          name: getFormatMessage('business_account_approve'),
          hidden: false,
          fixed: false,
          url: '/admin/admin-account',
        },
      ],
    },
    {
      type: SystemMenuType.Group,
      id: SystemMenuId.StudioManage,
      name: getFormatMessage('studio_management'),
      fixed: true,
      subMenus: [
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.TitleManage,
          icon: SpriteSvgType.ServiceMatchmaking,
          name: getFormatMessage('title_manage'),
          hidden: false,
          fixed: false,
          url: '/admin/close-open',
        },
      ],
    },
    {
      type: SystemMenuType.Group,
      id: SystemMenuId.BillingManage,
      name: getFormatMessage('billing_manage'),
      fixed: true,
      subMenus: [
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.PriceCalculator,
          icon: SpriteSvgType.Calculator,
          name: getFormatMessage('price_calculator'),
          hidden: false,
          fixed: false,
          url: '/admin/price-calculator',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.CompanyAuth,
          icon: SpriteSvgType.Hosting,
          name: getFormatMessage('menu_company_auth'),
          hidden: false,
          fixed: false,
          url: '/admin/company-auth',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.WithdrawalList,
          icon: SpriteSvgType.CustomData,
          name: getFormatMessage('withdrawal_list'),
          hidden: false,
          fixed: false,
          url: '/admin/fee',
        },
      ],
    },
    {
      type: SystemMenuType.Group,
      id: SystemMenuId.PlatformOperation,
      name: getFormatMessage('platform_operation'),
      fixed: true,
      subMenus: [
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.ServiceOnline,
          icon: SpriteSvgType.AutoTask,
          name: getFormatMessage('service_online'),
          hidden: false,
          fixed: false,
          url: '/admin/create-service',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.DownLoadManage,
          icon: SpriteSvgType.Commands,
          name: getFormatMessage('download_manage'),
          hidden: false,
          fixed: false,
          url: '/admin/download',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.DownLoadRecord,
          icon: SpriteSvgType.serviceDatabase,
          name: getFormatMessage('download_record'),
          hidden: false,
          fixed: false,
          url: '/admin/download-record',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.ServiceApplication,
          icon: SpriteSvgType.ServiceApplication,
          name: getFormatMessage('service_application'),
          hidden: false,
          fixed: false,
          url: '/admin/service',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.BusinessAccount,
          icon: SpriteSvgType.AccountApply,
          name: getFormatMessage('业务账户申请'),
          hidden: false,
          fixed: false,
          url: '/admin/business_account',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.UpgradeNotification,
          icon: SpriteSvgType.MessageUpgrade,
          name: getFormatMessage('upgrade_notification'),
          hidden: false,
          fixed: false,
          url: '/admin/upgrade-notification',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.DownLoadNews,
          icon: SpriteSvgType.DownloadNews,
          name: getFormatMessage('download_news'),
          hidden: false,
          fixed: false,
          url: '/admin/download-news',
        },

        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.APPConfig,
          icon: SpriteSvgType.Hosting,
          name: getFormatMessage('app_config'),
          hidden: !showDevMenu,
          fixed: false,
          url: '/admin/app-config',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.PermissionList,
          icon: SpriteSvgType.Store,
          name: getFormatMessage('permission_list'),
          hidden: !showDevMenu,
          fixed: false,
          url: '/admin/permission',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.SupportPermissionList,
          icon: SpriteSvgType.Store,
          name: getFormatMessage('support_permission_list'),
          hidden: !showDevMenu,
          fixed: false,
          url: '/admin/support-permission',
        },
      ],
    },

    {
      type: SystemMenuType.Group,
      id: SystemMenuId.CustomerService,
      name: getFormatMessage('customer_contact'),
      fixed: true,
      subMenus: [
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.MailRecord,
          icon: SpriteSvgType.serviceDatabase,
          name: getFormatMessage('mail_record'),
          hidden: false,
          fixed: false,
          url: '/admin/mail-record',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.MessagePush,
          icon: SpriteSvgType.MessagePush,
          name: getFormatMessage('message_push'),
          hidden: false,
          fixed: false,
          url: '/admin/message',
        },
        {
          type: SystemMenuType.Menu,
          id: SystemMenuId.BusinessNotice,
          icon: SpriteSvgType.BusinessNotice,
          name: getFormatMessage('business_notice'),
          hidden: false,
          fixed: false,
          url: '/admin/notice/list',
        },
      ],
    },
  ];
};

export const getCommonMenus = (): ISystemMenuItem[] => {
  return [
    // {
    //   type: SystemMenuType.Menu,
    //   id: SystemMenuId.Account,
    //   icon: SpriteSvgType.AccountCenter,
    //   name: 'Account Center',
    //   hidden: false,
    //   fixed: false,
    //   url: '/account/center',
    // },
    {
      type: SystemMenuType.Menu,
      id: SystemMenuId.Organization,
      icon: SpriteSvgType.Organization,
      name: 'Organization',
      hidden: false,
      fixed: false,
      url: '/organization',
    },
    {
      type: SystemMenuType.Menu,
      id: SystemMenuId.Message,
      icon: SpriteSvgType.Message,
      name: 'Message Center',
      hidden: false,
      fixed: false,
      url: '/message/center',
    },
  ];
};
